import Swiper from 'swiper'
import {
  Autoplay,
  Pagination,
  Navigation,
  Thumbs,
  EffectFade,
} from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
  const swiperHeader = new Swiper('.swiperHeader', {
    slidesPerView: 1,
    initialSlide: 0,
    loop: true,
    allowTouchMove: false,
    speed: 4000,
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: '.swiper-pagination-header',
      type: 'bullets',
      clickable: true,
    },
    modules: [Pagination, EffectFade, Autoplay],
  })

  const swiperAccommodationConfig = {
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 24,
    autoplay: {
      delay: 3400,
      pauseOnMouseEnter: true,
    },
    speed: 700,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 56,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next-accommodation',
      prevEl: '.swiper-button-prev-accommodation',
    },
    modules: [Navigation, Autoplay],
  }

  const swiperAccommodationSliders = document.querySelectorAll(
    '.swiperAccommodation'
  )
  swiperAccommodationSliders.forEach((element, index) => {
    new Swiper(element, {
      ...swiperAccommodationConfig,
    })
  })

  const swiperOfferConfig = {
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 24,
    autoplay: {
      delay: 2400,
      pauseOnMouseEnter: true,
    },
    speed: 700,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 56,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next-offer',
      prevEl: '.swiper-button-prev-offer',
    },
    modules: [Navigation, Autoplay],
  }

  const swiperOfferSliders = document.querySelectorAll('.swiperOffer')
  swiperOfferSliders.forEach((element, index) => {
    new Swiper(element, {
      ...swiperOfferConfig,
    })
  })

  const swiperSingleRoomThumbs = new Swiper('.swiperSingleRoomThumbs', {
    spaceBetween: 12,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      640: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
      },
    },
    modules: [Thumbs],
  })

  const swiperSingleRoomMain = new Swiper('.swiperSingleRoomMain', {
    spaceBetween: 5,
    navigation: {
      nextEl: '.swiper-button-next-single-room',
      prevEl: '.swiper-button-prev-single-room',
    },
    thumbs: {
      swiper: swiperSingleRoomThumbs,
    },
    breakpoints: {
      1024: {
        spaceBetween: 5,
      },
    },
    modules: [Navigation, Thumbs],
  })

  const swiperCarousel = new Swiper('.swiperCarousel', {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1.5,
    speed: 6000,
    autoplay: {
      delay: 0,
    },

    breakpoints: {
      640: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 'auto',
      },
    },
    modules: [Autoplay],
  })
})
